function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4308 3.60999C19.9201 3.099 19.3136 2.69364 18.6462 2.41708C17.9787 2.14052 17.2633 1.99817 16.5408 1.99817C15.8183 1.99817 15.1029 2.14052 14.4355 2.41708C13.768 2.69364 13.1616 3.099 12.6508 3.60999L11.5908 4.66999L10.5308 3.60999C9.49912 2.5783 8.09985 1.9987 6.64082 1.9987C5.18178 1.9987 3.78251 2.5783 2.75082 3.60999C1.71913 4.64169 1.13953 6.04096 1.13953 7.49999C1.13953 8.95903 1.71913 10.3583 2.75082 11.39L3.81082 12.45L11.5908 20.23L19.3708 12.45L20.4308 11.39C20.9418 10.8792 21.3472 10.2728 21.6237 9.60535C21.9003 8.93789 22.0426 8.22248 22.0426 7.49999C22.0426 6.77751 21.9003 6.0621 21.6237 5.39464C21.3472 4.72718 20.9418 4.12075 20.4308 3.60999V3.60999Z",
  stroke: "current",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgOutlineHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineHeart);
export default __webpack_public_path__ + "static/media/outline-heart.1d5a3796.svg";
export { ForwardRef as ReactComponent };